import { identity, pickBy } from "ramda";

export function queryParams(args) {
  const params = new URLSearchParams(pickBy(identity, args)).toString();
  return params ? `?${params}` : "";
}
